import React, { FC, useEffect, useState } from "react";
import {
  Wrapper,
  Container,
  DisableButton,
  ModalWrapper,
  ModalMessege,
  ModalAction,
  ModalImg,
  Delevered,
  Shipping,
  Received,
} from "./StyledPurchaseCoinList";
import * as TableStyle from "../../Lottery/LotteryList/StyledLottery";
import ViewHeader from "../../../components/ViewHeader/ViewHeader";
import TableHeaderComponent from "../../../components/TableHeader/TableHeader";
import Button from "../../../components/UI/Button/Button";

import useDimension from "../../../costomHook/useDimention";
import * as UIConstants from "../../../UIConstants";

import { adminRouts } from "../../../routs";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCoin,
  getCoins,
  getCoinsById,
  getPurchaseCoinList,
  publishCoin,
  updateCoinDeliveryStatus,
} from "../../../features/coinSlice";
import { RootState } from "../../../app/Store";
import {
  searchTableData,
  sortTableValues,
  tablePagination,
  transformDateTime,
} from "../../../Utility/Utility";
import EmptyTableView from "../../../components/EmptyTableView/EmptyTableView";
import TableFooter from "../../../components/TableFooter/TableFooter";
import { togglePublish } from "../../../features/loader";
import {
  resetImages,
  resetThumbnail,
  setImages,
  setThumbnail,
} from "../../../features/imageUploaderSlice";

import Modal from "../../../components/Modal/Modal";
import warning from "../../../assets/images/warningSign.png";
import ActionModal from "../../../components/Modal/ActionModal";
import JsonToCsv from "../../../components/JSONToCSV/JsonToCsv";
import { getUserList } from "../../../features/Users";

enum ButtonSize {
  sm = "small",
  md = "medium",
  lg = "large",
}
enum ButtonVariant {
  primaryFilled = "primary-filled",
  secondary = "secondary",
  primaryLink = "primaryLink",
  danger = "danger",
  dangerOutline = "dangerOutline",
}

class TableHeader {
  constructor(
    public label: string,
    public isSortRequired: boolean,
    public isAscSorted: boolean,
    public isDscSorted: boolean,
    public id: string
  ) {}
}
let tableHeaders = [
  new TableHeader("Coin ID", true, false, false, "coinId"),
  new TableHeader("User ID", true, false, false, "userId"),
  new TableHeader("PurchaseSlNo", false, false, false, "purchaseSlNo"),
  new TableHeader("PurchaseDate", false, false, false, "purchaseDate"),
  new TableHeader("Price", false, false, false, "coinPrice"),
  new TableHeader("Delivery Status", false, false, false, "coinDeliveryStatus"),

  // new TableHeader("Description", false, false, false, "coinDescription"),
];

let tabMenuViewList = [
  {
    label: "Received List",
    id: "RECEIVED_1",
    queryParam: "RECIEVED",
    isActive: true,
    isSerarchViewActive: false,
  },
  {
    label: "Shipping List",
    id: "SHIPPING_2",
    queryParam: "SHIPPING",
    isActive: false,
    isSerarchViewActive: false,
  },
  {
    label: "Delivered List",
    id: "DELIVERED_3",
    queryParam: "DELIVERED",
    isActive: false,
    isSerarchViewActive: false,
  },
];

interface statusProp {
  purchaseId: any;
  coinDeliveryStatus: any;
}

const PurchaseCoinList: FC = () => {
  const [tabMenu, setTabMenu] = useState(tabMenuViewList);

  const [tableHeaderValues, setHeaderValues] = useState(tableHeaders);
  const dimention = useDimension();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const mainList = useSelector((state: RootState) => state.coin.purchaseList);
  const coinList =[...mainList].reverse();

  console.log("isPublish ", mainList,coinList);
  const [originalResponse, setOriginalResponse] = useState<any>([]);
  const [totalResponseLength, setResponseLength] = useState(0);
  const [responseData, setResponseData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [tableSearch, setSearch] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [status, setStatus] = useState<statusProp>({
    purchaseId: "",
    coinDeliveryStatus: "",
  });


  useEffect(() => {
    if (mainList.length > 0) {
      setResponseLength(coinList.length);
      setOriginalResponse(coinList);
      let pagedResponse = tablePagination(coinList, 1);
      if (pagedResponse.isValidResponse) {
        setResponseData(pagedResponse.data);
      } else {
        setResponseData([]);
      }
    }else{
      setResponseData([])
    }
  }, [mainList]);

  const redirectToView = (path: string) => {
    navigate(path);
  };

  useEffect(() => {
    getTableData(tabMenu);
  }, []);

  const updateTabMenuOption = (selectedMenuId: any) => {
    let updatedMenuArray = tabMenu.map((menuObj: any) => {
      return {
        ...menuObj,
        isActive: menuObj.id === selectedMenuId,
      };
    });
    getTableData(updatedMenuArray);
    setTabMenu(updatedMenuArray);
  };

  const getTableData = (tabObj: any) => {
    let selectedObj = tabObj.filter((tabObj: any) => {
      return tabObj.isActive;
    })[0];
    // console.log("obj",selectedObj)
    dispatch(getPurchaseCoinList(`${selectedObj.queryParam}`));
    dispatch(getUserList(""))
  };

  const redirectToDetailView = (coinId: number) => {
    navigate(adminRouts.coinDetails(coinId));
    // console.log(coinId);
  };
  const redirectTouserDetailView = (userId: any) => {
    // navigate(adminRouts.viewUser(publicUserId));
    
        navigate(adminRouts.viewUser(userId))
     
    // console.log(userId);
  };

  const updatePageNumber = (pageNumber: any) => {
    if (originalResponse.length > 0) {
      let pagedResponse = tablePagination(originalResponse, pageNumber);
      if (pagedResponse.isValidResponse) {
        setPageNumber(pagedResponse.pageNumber);
        setResponseData(pagedResponse.data);
      }
    }
  };

  let tabMenuView = tabMenu.map((menuObj) => {
    return (
      <TableStyle.MenuOption
        onClick={() => {
          updateTabMenuOption(menuObj.id);
        }}
        isActive={menuObj.isActive}
        key={menuObj.id}
      >
        {menuObj.label}
      </TableStyle.MenuOption>
    );
  });

  const sortTable = (id: string, isSortAsc: boolean) => {
    let sortedArray: any = sortTableValues(originalResponse, id, !isSortAsc);
    setPageNumber(1);
    setOriginalResponse(sortedArray);
    // tableHeaderValues, setHeaderValues
    let pagedResponse = tablePagination(sortedArray, 1);
    setResponseData(pagedResponse.data);
    let updatedTableHeaders: any = [];
    for (let headerObj of tableHeaderValues) {
      if (headerObj.id === id) {
        let updatedObj = {
          ...headerObj,
          isAscSorted: !isSortAsc,
          isDscSorted: isSortAsc,
        };
        updatedTableHeaders.push(updatedObj);
      } else {
        let updatedObj = {
          ...headerObj,
          isAscSorted: false,
          isDscSorted: false,
        };
        updatedTableHeaders.push(updatedObj);
      }
    }
    setHeaderValues(updatedTableHeaders);
  };

  const deliveryStatusModalHandler = (
    purchaseId: any,
    coinDeliveryStatus: any
  ) => {
    console.log(coinDeliveryStatus, purchaseId);
    setStatus({
      purchaseId: purchaseId,
      coinDeliveryStatus: coinDeliveryStatus,
    });

    setOpenModal(true);
  };

  const deliveryStatusHandler = () => {
    // console.log(status)
    dispatch(
      updateCoinDeliveryStatus({
        purchaseId: status?.purchaseId,
        coinDeliveryStatus: status?.coinDeliveryStatus,
      })
    );
    setOpenModal(false);
  };

  const tableBody = responseData.map((tableRowObj: any) => {
    // console.log(tableRowObj);

    let idBtn = (
      <Button
        title={`${tableRowObj.coinId}`}
        btnSize={ButtonSize.sm}
        btnVariant={ButtonVariant.primaryLink}
        clicked={() => {
          redirectToDetailView(tableRowObj.coinId);
        }}
      />
    );
    let userIdBtn = (
      <Button
        title={`${tableRowObj.userId}`}
        btnSize={ButtonSize.sm}
        btnVariant={ButtonVariant.primaryLink}
        clicked={() => {
          redirectTouserDetailView(tableRowObj?.userId);
        }}
      />
    );

    return (
      <tr>
        <td>{idBtn}</td>
        <td>{userIdBtn}</td>
        <td>{tableRowObj.purchaseSlNo}</td>
        <td>{transformDateTime(tableRowObj.purchaseDate)}</td>
        <td>{tableRowObj.coinPrice}</td>
        <td>
          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div>
              {tableRowObj.coinDeliveryStatus === "DELIVERED" ? (
                <Delevered>DELIVERED</Delevered>
              ) : tableRowObj.coinDeliveryStatus === "SHIPPING" ? (
                <Shipping>SHIPPING</Shipping>
              ) : tableRowObj.coinDeliveryStatus === "RECIEVED" ? (
                <Received>RECIEVED</Received>
              ) : (
                tableRowObj.coinDeliveryStatus
              )}
            </div>

            {tableRowObj.coinDeliveryStatus !== "DELIVERED" && (
              <Button
                title={
                  tableRowObj.coinDeliveryStatus === "RECIEVED"
                    ? "Ship"
                    : tableRowObj.coinDeliveryStatus === "SHIPPING"
                    ? "Deliver"
                    : ""
                }
                btnSize={
                  dimention.width <= UIConstants.mobileWidth
                    ? ButtonSize.sm
                    : ButtonSize.sm
                }
                btnVariant={ButtonVariant.danger}
                clicked={() =>
                  deliveryStatusModalHandler(
                    tableRowObj.purchaseId,
                    tableRowObj.coinDeliveryStatus
                  )
                }
              />
            )}
          </div>
        </td>
      </tr>
    );
  });

  const setTableSearchValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  const triggerSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      let searchResponse = searchTableData(originalResponse, tableSearch);
      if (searchResponse.length > 0) {
        setResponseData(searchResponse);
        setPageNumber(1);
        setResponseLength(searchResponse.length);
      }
    }
  };

  return (
    <Wrapper>
      <Container>
        <ActionModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          title={
            status.coinDeliveryStatus === "RECIEVED"
              ? "Ship"
              : status.coinDeliveryStatus === "SHIPPING"
              ? "Deliver"
              : ""
          }
          confirm={deliveryStatusHandler}
          content={"Coin"}
        />

        <TableStyle.BreadcrumbSection>
          <ViewHeader title={"Purchased Coins"} />
          <JsonToCsv fileLabel="purchaseCoinData" data={coinList} />
        </TableStyle.BreadcrumbSection>
      </Container>
      <TableStyle.ContentSection>
        <TableStyle.SearchSectionContainer>
          <TableStyle.Input
            value={tableSearch}
            onKeyDown={triggerSearch}
            onChange={setTableSearchValue}
            placeholder="Search"
          />
        </TableStyle.SearchSectionContainer>
        <TableStyle.TabMenuContainer>{tabMenuView}</TableStyle.TabMenuContainer>
        <TableStyle.TableWrapper>
          <TableStyle.Table>
            <TableHeaderComponent
              headers={tableHeaderValues}
              onToggleSort={sortTable}
            />
            <TableStyle.Tbody>{tableBody}</TableStyle.Tbody>
          </TableStyle.Table>
          {responseData.length === 0 && <EmptyTableView />}
          <TableFooter
            totalCount={totalResponseLength}
            currentPageNumber={pageNumber}
            updatePageNumber={updatePageNumber}
          />
        </TableStyle.TableWrapper>
      </TableStyle.ContentSection>
    </Wrapper>
  );
};

export default PurchaseCoinList;
